export const CHANNEL_AUTH_USER_SERVICE: string = "AuthUserServiceChannel";
export const ENCODABLE_TYPE_ERRORS: string = "com.bcdfx.broker.ErrorsImpl";
export const CUBIQ_AUTH_CHANNEL = "CUBIQ_AUTH";
export const CHANNEL_TOKEN_SERVICE = "TokenServiceChannel";
export interface IAuthService {
  // login(username: string, password: string): Promise<boolean>;
  // logout(): Promise<boolean>;
  // isAuth(): Promise<boolean>;
  isResetRequested(): Promise<boolean>;
  disconnectOnLogout(): Promise<any>;
}
